import { PropTypes } from "prop-types"

function BlockAccordion({ children }) {
  return <div className="oj-block-accordion">{children}</div>
}

BlockAccordion.propTypes = {
  children: PropTypes.node.isRequired
}

export default BlockAccordion
